import { twMerge } from 'tailwind-merge';

interface PropTypes {
  children: React.ReactNode;
  className?: string;
}

export default function Container({ children, className }: PropTypes) {
  return (
    <div className={twMerge(`mx-auto px-3 lg:max-w-7xl lg:px-2`, className)}>
      {children}
    </div>
  );
}
